document.addEventListener('DOMContentLoaded', function() {
  const reservationButton = document.getElementById('reservationButton');
  const storeOverlay = document.getElementById('storeOverlay');
  const closeOverlay = document.getElementById('closeOverlay');
  const overlayContent = document.querySelector('.overlay-content');

  if (reservationButton) {
    reservationButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (storeOverlay) {
        storeOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // 背景のスクロールを防ぐ
      }
    });
  }

  if (closeOverlay) {
    closeOverlay.addEventListener('click', function() {
      if (storeOverlay) {
        storeOverlay.style.display = 'none';
        document.body.style.overflow = ''; // 背景のスクロールを元に戻す
      }
    });
  }

  // オーバーレイの外側をクリックしても閉じないように変更
  if (overlayContent) {
    overlayContent.addEventListener('click', function(e) {
      e.stopPropagation(); // クリックイベントの伝播を止める
    });
  }
});